import Box from '@material-ui/core/Box'
import IconButton from '@material-ui/core/IconButton'
import { makeStyles } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { TbSearch } from 'react-icons/tb'
import { useHistory } from 'react-router-dom'

import colorContext from '../../Context/colorContext'
import useDebounce from '../../hooks/use.debounce'
import theme from '../../services/theme-service'
import SearchInputDropdown from './components/SearchInputDropdown'

interface SearchInputProps {
  placeholder?: string
}

export default function SearchInput({ placeholder }: SearchInputProps) {
  const { debounce } = useDebounce()
  const history = useHistory()
  const [dropdownVisible, setDropdownVisible] = useState(false)
  const [textSearch, setTextSearch] = useState<string>('')
  const [debouncedValue, setDebouncedValue] = useState('')
  const inputRef = useRef<HTMLInputElement>(null)
  const dropdownRef = useRef<HTMLDivElement>(null)
  const matchesMobile = useMediaQuery('(max-width: 660px)')

  const { colors } = useContext(colorContext)

  const useStyles = makeStyles(() => ({
    inputSearch: {
      height: 50,
      borderRadius: 0,
      width: '100%',
      border: 'none',
      outline: 'none',
      paddingLeft: 16,
      color: colors.textBody,
      background: colors.colorBackground,
      '&::placeholder': {
        color: 'rgba(31, 41, 55, 0.5)',
      },
    },
    buttonSearch: {
      background: theme.palette.primary.main,
      '&:hover': {
        background: theme.palette.primary.main,
      },
    },
    iconSearch: {
      color: '#fff',
    },
  }))

  const classes = useStyles()

  const submitSearch = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (textSearch) {
      const formattedSearchText = textSearch.replaceAll('/', '')
      history.push(`/buscar/q=${formattedSearchText}`)
      setTextSearch('')
    }
  }

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTextSearch(event.target.value)
    setDropdownVisible(true)
    debounce(() => {
      setDebouncedValue(event.target.value)
    }, 500)
  }

  const handleClickOutside = (event: MouseEvent) => {
    if (
      inputRef.current &&
      !inputRef.current.contains(event.target as Node) &&
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setDropdownVisible(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <Box
      style={{
        position: 'relative',
      }}
    >
      <form
        onSubmit={submitSearch}
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          flexGrow: 1,
          minWidth: 300,
        }}
      >
        <input
          value={textSearch}
          onChange={handleInputChange}
          ref={inputRef}
          className={classes.inputSearch}
          style={{
            maxWidth: matchesMobile ? '' : 300,
            width: '100%',
            borderRadius: '4px 0px 0px 4px',
            border: `1px solid ${theme.palette.primary.main}`,
          }}
          placeholder={placeholder}
        />
        <IconButton
          type="submit"
          className={classes.buttonSearch}
          style={{
            borderRadius: '0px 4px 4px 0px',
          }}
        >
          <TbSearch fontSize="default" className={classes.iconSearch} />
        </IconButton>
      </form>
      {dropdownVisible && (
        <SearchInputDropdown
          dropdownRef={dropdownRef}
          inputValue={debouncedValue}
        />
      )}
    </Box>
  )
}
